import React, { useEffect, useState } from "react";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import {
    getListaGraficoEnergiaMesesAno,
    montarGraficoColunasEnergiaMesesAno,
    setDataGrafico,
    incluirEnergiaMes,
    incluirEnergiaAno,
} from "../geracaoLeituraActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { DefinirEnergiaMesForm } from "./DefinirEnergiaMesForm.jsx";
import { DefinirEnergiaAnoForm } from "./DefinirEnergiaAnoForm.jsx";

function GraficoAnoComponent(props) {
    const [graficoAno, setGraficoAno] = useState(null);
    const [formularioAjusteManualAberto, setFormularioAjusteManualAberto] = useState();

    const podeIncluirRegistrosManualmente =
        // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/geracaoLeitura.js (salvarEnergiaMes, salvarEnergiaAno) e nos endpoints POST /api/geracaoLeitura/energiaMes e POST /api/geracaoLeitura/energiaAno
        !props.filtro.agrupar_por_uc && props.registro.id_geracao_integracao && !props.usuarioLogado.acesso_cliente && props.usuarioLogado.acesso_solar_editar;

    const exibirFormularioIncluirEnergiaMesAnoTotal = props.modoTela === "graficoEnergiaMesesAno" && podeIncluirRegistrosManualmente;

    const exibirFormularioIncluirEnergiaMes = !formularioAjusteManualAberto || formularioAjusteManualAberto === "energia_mes";
    const exibirFormularioIncluirEnergiaAno = !formularioAjusteManualAberto || formularioAjusteManualAberto === "energia_ano";

    useEffect(() => {
        props.getListaGraficoEnergiaMesesAno({
            id_agrupador: props.filtro.agrupar_por_uc ? props.registro.id_unidade_consumidora : props.registro.id_geracao_integracao,
            data: props.dataGrafico,
        });
    }, [props.filtro.agrupar_por_uc, props.registro.id_unidade_consumidora, props.registro.id_geracao_integracao, props.dataGrafico]);

    useEffect(() => {
        montarGraficoColunasEnergiaMesesAno({
            id: "graficoEnergiaAno",
            lista: props.listaGraficoEnergiaMesesAno,
            setChart: setGraficoAno,
            subtitulo: props.registro.nome_unidade_consumidora,
        });
        return () => {
            if (graficoAno) {
                graficoAno.dispose();
            }
        };
    }, [props.listaGraficoEnergiaMesesAno, props.registro.nome_unidade_consumidora]);

    function voltarAvancarDataGrafico({ dataGrafico, tempo }) {
        const novaData = new Date(dataGrafico);
        novaData.setUTCFullYear(novaData.getUTCFullYear() + tempo);
        props.setDataGrafico(novaData.toISOString().substring(0, 10));
    }

    function getEstiloBotao(desabilitado) {
        return {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "1.5rem",
            fontWeight: 500,
            boxShadow: desabilitado ? "inset 0 0 16px 1px #ccc" : "0 0 10px 1px #ccc",
            color: "#0070cc",
            width: 40,
            height: 40,
            borderRadius: "100%",
            backgroundColor: "#fff",
            border: "none",
            marginInline: 20,
        };
    }

    return (
        <Row>
            <Grid cols="12 4 4 4"></Grid>
            <Grid
                cols="12 4 4 4"
                style={{
                    display: "flex",
                    minWidth: "fit-content",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingTop: 10,
                }}
            >
                <button
                    style={getEstiloBotao()}
                    onFocus={(e) => {
                        e.target.style.outline = "none";
                    }}
                    onClick={() => {
                        voltarAvancarDataGrafico({
                            dataGrafico: props.dataGrafico,
                            tempo: -1,
                        });
                    }}
                    disabled={props.dataGrafico.substring(0, 4) === "2023"}
                >
                    {"<"}
                </button>
                <select
                    style={{
                        marginLeft: 5,
                        fontSize: "1.2rem",
                        padding: 7,
                        border: "1px solid #999",
                        backgroundColor: "#fff",
                        borderRadius: 10,
                    }}
                    value={props.dataGrafico.substring(0, 4)}
                    onFocus={(e) => (e.target.style.outline = "none")}
                    onChange={(e) => {
                        const novaData = e.target.value + "01-01";
                        props.setDataGrafico(novaData);
                    }}
                >
                    {(() => {
                        let options = [];
                        let anoInicioLeituras = 2023;
                        for (let i = anoInicioLeituras; i <= new Date().getFullYear(); i++) {
                            options.push(
                                <option key={i} value={String(i)}>
                                    {i}
                                </option>
                            );
                        }
                        return options;
                    })()}
                </select>
                <button
                    style={getEstiloBotao(props.dataGrafico.substring(0, 4) === new Date().toISOString().substring(0, 4))}
                    onFocus={(e) => {
                        e.target.style.outline = "none";
                    }}
                    onClick={() => {
                        voltarAvancarDataGrafico({
                            dataGrafico: props.dataGrafico,
                            tempo: 1,
                        });
                    }}
                    disabled={props.dataGrafico.substring(0, 4) === new Date().toISOString().substring(0, 4)}
                >
                    {">"}
                </button>
            </Grid>
            {exibirFormularioIncluirEnergiaMesAnoTotal ? (
                <Grid cols="12 4 4 4" style={{ paddingTop: 28 }}>
                    <Row>
                        {exibirFormularioIncluirEnergiaMes && (
                            <Grid cols={formularioAjusteManualAberto ? "12 12 12 12" : "6 6 6 6"}>
                                <DefinirEnergiaMesForm
                                    callbackOpenForm={() => setFormularioAjusteManualAberto("energia_mes")}
                                    callbackCloseForm={() => setFormularioAjusteManualAberto()}
                                    dataGrafico={props.dataGrafico}
                                    idGeracaoIntegracao={props.registro.id_geracao_integracao}
                                    handleSubmit={(form) => {
                                        setFormularioAjusteManualAberto(null);
                                        props.incluirEnergiaMes({
                                            registro: form,
                                            callback: () => {
                                                props.getListaGraficoEnergiaMesesAno({ id_agrupador: props.registro.id_geracao_integracao, data: props.dataGrafico });
                                            },
                                        });
                                    }}
                                />
                            </Grid>
                        )}
                        {exibirFormularioIncluirEnergiaAno && (
                            <Grid cols={formularioAjusteManualAberto ? "12 12 12 12" : "6 6 6 6"}>
                                <DefinirEnergiaAnoForm
                                    callbackOpenForm={() => setFormularioAjusteManualAberto("energia_ano")}
                                    callbackCloseForm={() => setFormularioAjusteManualAberto()}
                                    dataGrafico={props.dataGrafico}
                                    idGeracaoIntegracao={props.registro.id_geracao_integracao}
                                    handleSubmit={(form) => {
                                        setFormularioAjusteManualAberto(null);
                                        props.incluirEnergiaAno({
                                            registro: form,
                                            callback: () => props.getListaGraficoEnergiaMesesAno({ id_agrupador: props.registro.id_geracao_integracao, data: props.dataGrafico }),
                                        });
                                    }}
                                />
                            </Grid>
                        )}
                    </Row>
                </Grid>
            ) : null}

            <div
                id="graficoEnergiaAno"
                style={{
                    width: "100%",
                    backgroundColor: "#ffffff",
                    height: 600,
                    borderRadius: "0 0 8px 8px",
                    overflow: "hidden",
                }}
            ></div>
        </Row>
    );
}

const mapStateToProps = (state) => {
    return {
        usuarioLogado: state.auth.usuarioLogado,
        filtro: state.geracaoLeitura.filtro,
        modoTela: state.geracaoLeitura.modoTela,
        registro: state.geracaoLeitura.registro,
        dataGrafico: state.geracaoLeitura.dataGrafico,
        listaGraficoEnergiaMesesAno: state.geracaoLeitura.listaGraficoEnergiaMesesAno,
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getListaGraficoEnergiaMesesAno,
            setDataGrafico,
            incluirEnergiaMes,
            incluirEnergiaAno,
        },
        dispatch
    );
export const GraficoAno = connect(mapStateToProps, mapDispatchToProps)(GraficoAnoComponent);
